import React from "react";
import Lottie from "lottie-react";
import giftingAnimation from "../assets/lottie/gift.json";
import { IonModal } from "@ionic/react";
import Button from "./Button";
import { GiftingModalStyled } from "../styles/components/giftingmodal";

interface GiftingModelProps {
  onAccept: Function;
  isOpen: boolean;
  onDismiss: Function;
  message: string
}

const GiftingModal: React.FC<GiftingModelProps> = ({
  onAccept,
  isOpen,
  onDismiss,
  message
}) => {
  return (
    <IonModal
      onDidDismiss={() => onDismiss()}
      breakpoints={[0.1, 0.6, 1]}
      initialBreakpoint={0.6}
      isOpen={isOpen}
    >
      <GiftingModalStyled>
        <div className="box">
          <Lottie animationData={giftingAnimation} loop={true} />
        </div>
        <div className="wrapper">
          <p className="title">
            {message}
          </p>
          <Button title="Redeem Gift" onClick={() => onAccept()}></Button>
        </div>

      </GiftingModalStyled>
    </IonModal>
  );
};

export default GiftingModal;
